import { Box } from '@mui/material';
import SearchBar from '../../SearchBar/SearchBar';
import { UserActionsStyles } from './StyledComponents';
import { UserMenu } from './UserMenu';
import { ApplicationsNavMenu } from '../../../components/ApplicationsNavMenu/ApplicationsNavMenu';

export const UserActions = ({ isAuthenticated }) => {
  return (
    <Box sx={UserActionsStyles}>
      {isAuthenticated && <SearchBar />}
      {isAuthenticated && <ApplicationsNavMenu />}
      <UserMenu />
    </Box>
  );
};
